<div class="square-btn"  
  [class.disabled]="isDisabled()"
  (click)="clickHandler()"
  tappable>
  <div class="content">
    <ion-icon src="../../assets/images/{{icon}}.svg"></ion-icon>
    <p>{{ label }}</p>
  </div>
</div>